export default theme => ({
  title: {
    marginTop: "16px",
    marginBottom: "8px",
  },
  instructions: {
    marginBottom: "16px",
    display: "block",
  },
  accordion: {
    marginBottom: "8px",
  },
  programAccordion: {
    marginBottom: "8px",
    marginTop: "16px",
  },
  accordionSummaryContainer: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    gap: "12px",
  },
  accordionSummaryContent: {
    flex: 1,
    minWidth: 0,
  },
  accordionSummaryLabel: {
    fontWeight: "500",
  },
  accordionSummaryDescription: {
    marginTop: "4px",
    display: "block",
  },
  accordionSummaryError: {
    color: "#d32f2f",
    fontWeight: "bold",
  },
  accordionSummaryActions: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    flexShrink: 0,
  },
  accordionDetails: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "16px",
  },
  programTitle: {
    flex: 1,
  },
});
